var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageLogin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u5207\u7247") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39CF8F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEDCC7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B7FFDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7FFF5",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 31.2958691,
    height: 24.7863248
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9DE8CE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#64CCA0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D1F9EA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A4F1D0",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-7",
    x: 0,
    y: 0,
    width: 24.7863248,
    height: 17.3504274,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "7.4\\u7248\\u672C\\u754C\\u9762",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4h-\\u672A\\u767B\\u5F55",
    transform: "translate(-490.000000, -271.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F39\\u5C42",
    transform: "translate(180.000000, 90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(280.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u6807/\\u7F3A\\u7701\\u9875/\\u64CD\\u4F5C\\u6210\\u529F",
    transform: "translate(30.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-3",
    transform: "translate(1.749689, 2.111796)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-1)",
    x: 40.2503109,
    y: 40.8882043,
    width: 7,
    height: 27
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#BDF4DB",
    x: 37.2503109,
    y: 40.8882043,
    width: 3,
    height: 27
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.342956,41.3497428 L23.342956,7.88820433 L54.331249,7.88820433 L54.3314456,7.90513183 C60.8908726,8.245362 66.1047532,13.6716936 66.1047532,20.3157922 L66.1047532,41.3497428 L23.342956,41.3497428 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#93F3C8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2",
    transform: "translate(10.335522, 7.888204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0128205,0 C20.1996028,-1.32019049e-15 26.025641,5.82603819 26.025641,13.0128205 L26.025641,33.4615385 L26.025641,33.4615385 L0,33.4615385 L0,13.0128205 C8.96229843e-16,5.82603819 5.82603819,1.32019049e-15 13.0128205,0 Z",
    id: "\\u77E9\\u5F62",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0128205,2.47863248 C18.8306919,2.47863248 23.5470085,7.19494911 23.5470085,13.0128205 L23.5470085,33.4615385 L23.5470085,33.4615385 L2.47863248,33.4615385 L2.47863248,13.0128205 C2.47863248,7.19494911 7.19494911,2.47863248 13.0128205,2.47863248 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-3",
    fill: "#59C895"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0128205,2.47863248 C13.605333,2.47863248 14.18642,2.52755059 14.7522632,2.62156843 C9.7618472,3.45071041 5.95726496,7.78746156 5.95726496,13.0128205 L5.95726496,13.0128205 L5.95726496,33.4615385 L2.47863248,33.4615385 L2.47863248,13.0128205 C2.47863248,7.19494911 7.19494911,2.47863248 13.0128205,2.47863248 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fill: "#4EB586",
    opacity: 0.300000012
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(2.586662, 32.922793)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8499\\u7248"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-4)",
    id: "\\u7F16\\u7EC4-4"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6.424296, 0.569464)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.534485, 11.642777) rotate(7.000000) translate(-20.534485, -11.642777) translate(0.991447, 2.312148)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8521997,2.89843402 L39.0860756,0.0456727666 L29.1836278,10.7306947 C24.4974408,15.7872234 17.9154156,18.6612587 11.0213,18.6612587 C8.53446702,18.6612587 6.51849056,16.6452822 6.51849056,14.1584492 C6.51849056,12.970157 6.98820789,11.8300379 7.82525891,10.9866021 L15.8521997,2.89843402 L15.8521997,2.89843402 Z",
    id: "\\u8DEF\\u5F84-7\\u5907\\u4EFD",
    fill: "url(#linearGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9620271,2.64742794 L36.5235974,-1.38701225e-13 L27.9130365,9.24186998 C23.3850322,14.1018586 17.0511516,16.8763974 10.4087716,16.9095648 C8.11844476,16.921001 6.25249707,15.0735952 6.24106079,12.7832684 C6.23537403,11.644388 6.69831195,10.5532908 7.52125323,9.76598624 L14.9620271,2.64742794 L14.9620271,2.64742794 Z",
    id: "\\u8DEF\\u5F84-7",
    fill: "url(#linearGradient-6)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-2",
    transform: "translate(3.278452, 16.439499)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "#FECE75",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.85817543,5.38091964 L28.6445002,5.38091964 L13.4289516,16.8523856 C12.7098191,17.3945615 11.7170108,17.3892067 11.0037684,16.8393052 L-3.85817543,5.38091964 L-3.85817543,5.38091964 Z",
    id: "\\u77E9\\u5F62\\u5907\\u4EFD-4",
    fill: "#F1B952",
    opacity: 0.5,
    mask: "url(#mask-8)",
    transform: "translate(12.393162, 11.575637) scale(1, -1) translate(-12.393162, -11.575637) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-3.85817543,-1.54327017 L28.6445002,-1.54327017 L13.4289516,9.92819575 C12.7098191,10.4703717 11.7170108,10.4650169 11.0037684,9.91511538 L-3.85817543,-1.54327017 L-3.85817543,-1.54327017 Z",
    fill: "#FFECBE",
    mask: "url(#mask-8)"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageLogin);
export default __webpack_public_path__ + "static/media/message_login.3a9b675d55a128cb9955b7031d6ce308.svg";
export { ForwardRef as ReactComponent };